import { SET_CHECKOUT_ITEMS } from './checkoutItem.action';

const initialState = {
  items: [],
};

const checkoutItemReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_CHECKOUT_ITEMS:
      return {
        ...state,
        items: action.payload,
      };
    default:
      return state;
  }
};

export default checkoutItemReducer;

export const selectSavedCheckoutItems = (state) => state.checkoutItems.items;
